export const formatTimeToAmPm = (timeValue) => {
  if (!timeValue || typeof timeValue !== "string") {
    return "--";
  }

  const normalized = timeValue.trim();
  const match = normalized.match(/^(\d{1,2}):(\d{2})(?::\d{2})?$/);

  if (!match) {
    return normalized;
  }

  const hours = Number(match[1]);
  const minutes = match[2];

  if (Number.isNaN(hours) || hours < 0 || hours > 23) {
    return normalized;
  }

  const period = hours >= 12 ? "PM" : "AM";
  const displayHours = hours % 12 || 12;

  return `${displayHours}:${minutes} ${period}`;
};

export const formatTimeRange = (startTime, endTime) => {
  const formattedStart = formatTimeToAmPm(startTime);
  const formattedEnd = formatTimeToAmPm(endTime);

  if (!endTime) {
    return formattedStart;
  }

  return `${formattedStart} - ${formattedEnd}`;
};
